module.exports = __webpack_public_path__ + "static/media/MU.144f2118.png";